import React from 'react';
import { UiGrid, UiFlex, UiButton, UiText } from '@open-stack/ui';
import clsx from 'clsx';
import styled from 'styled-components';
import { XText } from '../text/XText';

const Wrapper = styled(UiFlex)`
    &.disabled {
        opacity: 0.25;
    }
`;

export enum XSelectablesType {
    SINGLE = 'SINGLE',
    MULTIPLE = 'MULTIPLE',
}

export function useXSelectable<T = any>(props: XSelectablesProps<T>) {
    return {
        element: <XSelectables {...props} />,
    };
}

interface XSelectablesProps<T = any> {
    type: XSelectablesType;

    models: T[];

    onSelect(model: T): void;

    modelIsChecked(model: T): boolean;

    modelFormatter(model: T): {
        key: any;
        title: any;
        subtitle?: any;
        contentRight?: any;
    };

    disabled?: boolean;
}

export function XSelectables({
    type,
    models,
    onSelect,
    modelIsChecked,
    modelFormatter,
    disabled,
}: XSelectablesProps<any>) {
    const selected = models
        .filter(modelIsChecked)
        .map((item) => modelFormatter(item).key)
        .join('_');

    return (
        <UiGrid gap={0}>
            {models.map((model) => {
                const { key, title, subtitle, contentRight } = modelFormatter(model);
                const isSelected = modelIsChecked(model);

                const icons =
                    type === XSelectablesType.SINGLE
                        ? ['radio_button_checked', 'radio_button_unchecked']
                        : ['check_box', 'check_box_outline_blank'];

                return (
                    <Wrapper
                        onClick={() => onSelect(model)}
                        className={clsx(disabled && !isSelected && 'disabled')}
                        justifyContent="space-between"
                        gap={2}
                        key={key}>
                        <UiFlex gap={2}>
                            <UiButton
                                variant="text"
                                icon={isSelected ? icons[0] : icons[1]}
                                color={isSelected ? 'secondary' : 'default'}
                            />

                            <div>
                                <XText color={isSelected ? 'secondary' : 'text-primary'}>{title}</XText>

                                {subtitle && (
                                    <UiText display="block" color="text-secondary">
                                        {subtitle}
                                    </UiText>
                                )}
                            </div>
                        </UiFlex>

                        {contentRight && <UiText color="text-secondary">{contentRight}</UiText>}
                    </Wrapper>
                );
            })}
        </UiGrid>
    );
}
